import * as Types from '../../graphql/types'

import { gql } from 'apollo-boost'
import * as ApolloReactCommon from '@apollo/react-common'
import * as ApolloReactHooks from '@apollo/react-hooks'
const defaultOptions = {}
export type MessageAttachment_CustomerDocument_Fragment = {
  __typename?: 'CustomerDocument'
  checked?: boolean | null
  id: number
  name: string
  fileUrl: string
  createdAt: any
  previewImageUrl?: string | null
  fileFormat?: string | null
  documentDate?: any | null
  effective?: boolean | null
  category?: { __typename?: 'CustomerDocumentCategory'; id: number; name: string } | null
  metadata: {
    __typename?: 'MetaData'
    utilityBillCheck?: {
      __typename?: 'UtilityBillCheck'
      moveInDate?: string | null
      moveOutDate?: string | null
      sizeOfFlat?: number | null
      isCurrentAddress?: boolean | null
    } | null
  }
  identifiedClauses?: Array<{
    __typename?: 'IdentifiedClause'
    type: string
    effective: boolean
    spans: Array<{ __typename?: 'ClauseSpan'; text?: string | null; page?: number | null }>
  }> | null
}

export type MessageAttachment_LawyerDocument_Fragment = {
  __typename?: 'LawyerDocument'
  id: number
  name: string
  fileUrl: string
  createdAt: any
  previewImageUrl?: string | null
  fileFormat?: string | null
  documentDate?: any | null
  effective?: boolean | null
  identifiedClauses?: Array<{
    __typename?: 'IdentifiedClause'
    type: string
    effective: boolean
    spans: Array<{ __typename?: 'ClauseSpan'; text?: string | null; page?: number | null }>
  }> | null
}

export type MessageAttachmentFragment =
  | MessageAttachment_CustomerDocument_Fragment
  | MessageAttachment_LawyerDocument_Fragment

export type MessageFragment = {
  __typename?: 'Message'
  appointmentAt?: any | null
  approvedAt?: any | null
  content?: string | null
  createdAt: any
  id: number
  rejectionReason?: string | null
  sentAt?: any | null
  type: Types.MessageType
  updatedAt: any
  topicQuestionnaireAnswers?: any | null
  messageHasTemplate?: {
    __typename?: 'MessageHasTemplate'
    emailTemplate: { __typename?: 'EmailTemplate'; id: number; name: string }
  } | null
  documents?: Array<
    | {
        __typename?: 'CustomerDocument'
        checked?: boolean | null
        id: number
        name: string
        fileUrl: string
        createdAt: any
        previewImageUrl?: string | null
        fileFormat?: string | null
        documentDate?: any | null
        effective?: boolean | null
        category?: { __typename?: 'CustomerDocumentCategory'; id: number; name: string } | null
        metadata: {
          __typename?: 'MetaData'
          utilityBillCheck?: {
            __typename?: 'UtilityBillCheck'
            moveInDate?: string | null
            moveOutDate?: string | null
            sizeOfFlat?: number | null
            isCurrentAddress?: boolean | null
          } | null
        }
        identifiedClauses?: Array<{
          __typename?: 'IdentifiedClause'
          type: string
          effective: boolean
          spans: Array<{ __typename?: 'ClauseSpan'; text?: string | null; page?: number | null }>
        }> | null
      }
    | {
        __typename?: 'LawyerDocument'
        id: number
        name: string
        fileUrl: string
        createdAt: any
        previewImageUrl?: string | null
        fileFormat?: string | null
        documentDate?: any | null
        effective?: boolean | null
        identifiedClauses?: Array<{
          __typename?: 'IdentifiedClause'
          type: string
          effective: boolean
          spans: Array<{ __typename?: 'ClauseSpan'; text?: string | null; page?: number | null }>
        }> | null
      }
  > | null
  lawyer?: {
    __typename?: 'Lawyer'
    id: number
    firstName: string
    lastName: string
    profilePictureUrl: string
  } | null
  letterRequest?: {
    __typename?: 'LetterRequest'
    id: number
    powerOfAttorney?: {
      __typename?: 'PowerOfAttorney'
      uid: string
      state: Types.PowerOfAttorneyState
      deliveryMethod: Types.DeliveryMethod
    } | null
  } | null
  serviceComment?: {
    __typename?: 'ServiceComment'
    id: number
    comment: string
    updatedAt: any
  } | null
  topic: { __typename?: 'Topic'; id: number; name: string }
  case?: {
    __typename?: 'Case'
    id: number
    state: Types.CaseState
    origin?: string | null
    insuranceClaim?: {
      __typename?: 'InsuranceClaim'
      uuid: string
      insuredPropertyAffiliation?: Types.InsuredPropertyAffiliation | null
      insuredPropertyType?: Types.InsuredPropertyType | null
      services: Array<{ __typename?: 'InsuranceClaimService'; uuid: string; metadata?: any | null }>
    } | null
  } | null
  auditReport?: {
    __typename?: 'AuditReport'
    id: number
    report: {
      __typename?: 'ProfessionalAuditReport'
      auditType: Types.ProfessionalAuditType
      sections: Array<{
        __typename?: 'ProfessionalAuditSection'
        uid: string
        summary: any
        outcome?: Types.ProfessionalAuditOutcome | null
      }>
    }
  } | null
}

export type MembershipFragment = {
  __typename?: 'Membership'
  uuid: string
  membershipNumber: string
  activatedAt: any
  startsAt: any
  state: Types.MembershipState
  membershipTypeUid: string
  lawyerId: number
  advancedFrom?: { __typename?: 'Membership'; uuid: string } | null
  product: {
    __typename?: 'Product'
    id: number
    name: string
    type: string
    upgradesTo?: Array<number> | null
  }
}

export type CustomerFragment = {
  __typename?: 'Customer'
  id: number
  firstName?: string | null
  lastName?: string | null
  gender?: Types.Gender | null
  phone?: string | null
  mobilePhone?: string | null
  validGermanMobileNumber?: string | null
  profilePictureUrl?: string | null
  membership?: {
    __typename?: 'Membership'
    uuid: string
    membershipNumber: string
    activatedAt: any
    startsAt: any
    state: Types.MembershipState
    membershipTypeUid: string
    lawyerId: number
    advancedFrom?: { __typename?: 'Membership'; uuid: string } | null
    product: {
      __typename?: 'Product'
      id: number
      name: string
      type: string
      upgradesTo?: Array<number> | null
    }
  } | null
  lawyer?: {
    __typename?: 'Lawyer'
    id: number
    firstName: string
    lastName: string
    profilePictureUrl: string
  } | null
  latestQuestion?: {
    __typename?: 'Message'
    appointmentAt?: any | null
    approvedAt?: any | null
    content?: string | null
    createdAt: any
    id: number
    rejectionReason?: string | null
    sentAt?: any | null
    type: Types.MessageType
    updatedAt: any
    topicQuestionnaireAnswers?: any | null
    messageHasTemplate?: {
      __typename?: 'MessageHasTemplate'
      emailTemplate: { __typename?: 'EmailTemplate'; id: number; name: string }
    } | null
    documents?: Array<
      | {
          __typename?: 'CustomerDocument'
          checked?: boolean | null
          id: number
          name: string
          fileUrl: string
          createdAt: any
          previewImageUrl?: string | null
          fileFormat?: string | null
          documentDate?: any | null
          effective?: boolean | null
          category?: { __typename?: 'CustomerDocumentCategory'; id: number; name: string } | null
          metadata: {
            __typename?: 'MetaData'
            utilityBillCheck?: {
              __typename?: 'UtilityBillCheck'
              moveInDate?: string | null
              moveOutDate?: string | null
              sizeOfFlat?: number | null
              isCurrentAddress?: boolean | null
            } | null
          }
          identifiedClauses?: Array<{
            __typename?: 'IdentifiedClause'
            type: string
            effective: boolean
            spans: Array<{ __typename?: 'ClauseSpan'; text?: string | null; page?: number | null }>
          }> | null
        }
      | {
          __typename?: 'LawyerDocument'
          id: number
          name: string
          fileUrl: string
          createdAt: any
          previewImageUrl?: string | null
          fileFormat?: string | null
          documentDate?: any | null
          effective?: boolean | null
          identifiedClauses?: Array<{
            __typename?: 'IdentifiedClause'
            type: string
            effective: boolean
            spans: Array<{ __typename?: 'ClauseSpan'; text?: string | null; page?: number | null }>
          }> | null
        }
    > | null
    lawyer?: {
      __typename?: 'Lawyer'
      id: number
      firstName: string
      lastName: string
      profilePictureUrl: string
    } | null
    letterRequest?: {
      __typename?: 'LetterRequest'
      id: number
      powerOfAttorney?: {
        __typename?: 'PowerOfAttorney'
        uid: string
        state: Types.PowerOfAttorneyState
        deliveryMethod: Types.DeliveryMethod
      } | null
    } | null
    serviceComment?: {
      __typename?: 'ServiceComment'
      id: number
      comment: string
      updatedAt: any
    } | null
    topic: { __typename?: 'Topic'; id: number; name: string }
    case?: {
      __typename?: 'Case'
      id: number
      state: Types.CaseState
      origin?: string | null
      insuranceClaim?: {
        __typename?: 'InsuranceClaim'
        uuid: string
        insuredPropertyAffiliation?: Types.InsuredPropertyAffiliation | null
        insuredPropertyType?: Types.InsuredPropertyType | null
        services: Array<{
          __typename?: 'InsuranceClaimService'
          uuid: string
          metadata?: any | null
        }>
      } | null
    } | null
    auditReport?: {
      __typename?: 'AuditReport'
      id: number
      report: {
        __typename?: 'ProfessionalAuditReport'
        auditType: Types.ProfessionalAuditType
        sections: Array<{
          __typename?: 'ProfessionalAuditSection'
          uid: string
          summary: any
          outcome?: Types.ProfessionalAuditOutcome | null
        }>
      }
    } | null
  } | null
  latestAnswer?: { __typename?: 'Message'; id: number } | null
  chat: {
    __typename?: 'MessagesCollection'
    items: Array<{
      __typename?: 'Message'
      appointmentAt?: any | null
      approvedAt?: any | null
      content?: string | null
      createdAt: any
      id: number
      rejectionReason?: string | null
      sentAt?: any | null
      type: Types.MessageType
      updatedAt: any
      topicQuestionnaireAnswers?: any | null
      messageHasTemplate?: {
        __typename?: 'MessageHasTemplate'
        emailTemplate: { __typename?: 'EmailTemplate'; id: number; name: string }
      } | null
      documents?: Array<
        | {
            __typename?: 'CustomerDocument'
            checked?: boolean | null
            id: number
            name: string
            fileUrl: string
            createdAt: any
            previewImageUrl?: string | null
            fileFormat?: string | null
            documentDate?: any | null
            effective?: boolean | null
            category?: { __typename?: 'CustomerDocumentCategory'; id: number; name: string } | null
            metadata: {
              __typename?: 'MetaData'
              utilityBillCheck?: {
                __typename?: 'UtilityBillCheck'
                moveInDate?: string | null
                moveOutDate?: string | null
                sizeOfFlat?: number | null
                isCurrentAddress?: boolean | null
              } | null
            }
            identifiedClauses?: Array<{
              __typename?: 'IdentifiedClause'
              type: string
              effective: boolean
              spans: Array<{
                __typename?: 'ClauseSpan'
                text?: string | null
                page?: number | null
              }>
            }> | null
          }
        | {
            __typename?: 'LawyerDocument'
            id: number
            name: string
            fileUrl: string
            createdAt: any
            previewImageUrl?: string | null
            fileFormat?: string | null
            documentDate?: any | null
            effective?: boolean | null
            identifiedClauses?: Array<{
              __typename?: 'IdentifiedClause'
              type: string
              effective: boolean
              spans: Array<{
                __typename?: 'ClauseSpan'
                text?: string | null
                page?: number | null
              }>
            }> | null
          }
      > | null
      lawyer?: {
        __typename?: 'Lawyer'
        id: number
        firstName: string
        lastName: string
        profilePictureUrl: string
      } | null
      letterRequest?: {
        __typename?: 'LetterRequest'
        id: number
        powerOfAttorney?: {
          __typename?: 'PowerOfAttorney'
          uid: string
          state: Types.PowerOfAttorneyState
          deliveryMethod: Types.DeliveryMethod
        } | null
      } | null
      serviceComment?: {
        __typename?: 'ServiceComment'
        id: number
        comment: string
        updatedAt: any
      } | null
      topic: { __typename?: 'Topic'; id: number; name: string }
      case?: {
        __typename?: 'Case'
        id: number
        state: Types.CaseState
        origin?: string | null
        insuranceClaim?: {
          __typename?: 'InsuranceClaim'
          uuid: string
          insuredPropertyAffiliation?: Types.InsuredPropertyAffiliation | null
          insuredPropertyType?: Types.InsuredPropertyType | null
          services: Array<{
            __typename?: 'InsuranceClaimService'
            uuid: string
            metadata?: any | null
          }>
        } | null
      } | null
      auditReport?: {
        __typename?: 'AuditReport'
        id: number
        report: {
          __typename?: 'ProfessionalAuditReport'
          auditType: Types.ProfessionalAuditType
          sections: Array<{
            __typename?: 'ProfessionalAuditSection'
            uid: string
            summary: any
            outcome?: Types.ProfessionalAuditOutcome | null
          }>
        }
      } | null
    }>
  }
  purchases: {
    __typename?: 'PurchasesCollection'
    last?: {
      __typename?: 'Purchase'
      id: number
      product?: {
        __typename?: 'Product'
        id: number
        name: string
        type: string
        upgradesTo?: Array<number> | null
      } | null
    } | null
  }
  note?: { __typename?: 'CustomerNote'; id: number; note: string } | null
}

export type CustomerAsLawyerQueryVariables = Types.Exact<{
  customerId: Types.Scalars['Int']
}>

export type CustomerAsLawyerQuery = {
  __typename?: 'Query'
  customer: {
    __typename?: 'Customer'
    id: number
    firstName?: string | null
    lastName?: string | null
    gender?: Types.Gender | null
    phone?: string | null
    mobilePhone?: string | null
    validGermanMobileNumber?: string | null
    profilePictureUrl?: string | null
    membership?: {
      __typename?: 'Membership'
      uuid: string
      membershipNumber: string
      activatedAt: any
      startsAt: any
      state: Types.MembershipState
      membershipTypeUid: string
      lawyerId: number
      advancedFrom?: { __typename?: 'Membership'; uuid: string } | null
      product: {
        __typename?: 'Product'
        id: number
        name: string
        type: string
        upgradesTo?: Array<number> | null
      }
    } | null
    lawyer?: {
      __typename?: 'Lawyer'
      id: number
      firstName: string
      lastName: string
      profilePictureUrl: string
    } | null
    latestQuestion?: {
      __typename?: 'Message'
      appointmentAt?: any | null
      approvedAt?: any | null
      content?: string | null
      createdAt: any
      id: number
      rejectionReason?: string | null
      sentAt?: any | null
      type: Types.MessageType
      updatedAt: any
      topicQuestionnaireAnswers?: any | null
      messageHasTemplate?: {
        __typename?: 'MessageHasTemplate'
        emailTemplate: { __typename?: 'EmailTemplate'; id: number; name: string }
      } | null
      documents?: Array<
        | {
            __typename?: 'CustomerDocument'
            checked?: boolean | null
            id: number
            name: string
            fileUrl: string
            createdAt: any
            previewImageUrl?: string | null
            fileFormat?: string | null
            documentDate?: any | null
            effective?: boolean | null
            category?: { __typename?: 'CustomerDocumentCategory'; id: number; name: string } | null
            metadata: {
              __typename?: 'MetaData'
              utilityBillCheck?: {
                __typename?: 'UtilityBillCheck'
                moveInDate?: string | null
                moveOutDate?: string | null
                sizeOfFlat?: number | null
                isCurrentAddress?: boolean | null
              } | null
            }
            identifiedClauses?: Array<{
              __typename?: 'IdentifiedClause'
              type: string
              effective: boolean
              spans: Array<{
                __typename?: 'ClauseSpan'
                text?: string | null
                page?: number | null
              }>
            }> | null
          }
        | {
            __typename?: 'LawyerDocument'
            id: number
            name: string
            fileUrl: string
            createdAt: any
            previewImageUrl?: string | null
            fileFormat?: string | null
            documentDate?: any | null
            effective?: boolean | null
            identifiedClauses?: Array<{
              __typename?: 'IdentifiedClause'
              type: string
              effective: boolean
              spans: Array<{
                __typename?: 'ClauseSpan'
                text?: string | null
                page?: number | null
              }>
            }> | null
          }
      > | null
      lawyer?: {
        __typename?: 'Lawyer'
        id: number
        firstName: string
        lastName: string
        profilePictureUrl: string
      } | null
      letterRequest?: {
        __typename?: 'LetterRequest'
        id: number
        powerOfAttorney?: {
          __typename?: 'PowerOfAttorney'
          uid: string
          state: Types.PowerOfAttorneyState
          deliveryMethod: Types.DeliveryMethod
        } | null
      } | null
      serviceComment?: {
        __typename?: 'ServiceComment'
        id: number
        comment: string
        updatedAt: any
      } | null
      topic: { __typename?: 'Topic'; id: number; name: string }
      case?: {
        __typename?: 'Case'
        id: number
        state: Types.CaseState
        origin?: string | null
        insuranceClaim?: {
          __typename?: 'InsuranceClaim'
          uuid: string
          insuredPropertyAffiliation?: Types.InsuredPropertyAffiliation | null
          insuredPropertyType?: Types.InsuredPropertyType | null
          services: Array<{
            __typename?: 'InsuranceClaimService'
            uuid: string
            metadata?: any | null
          }>
        } | null
      } | null
      auditReport?: {
        __typename?: 'AuditReport'
        id: number
        report: {
          __typename?: 'ProfessionalAuditReport'
          auditType: Types.ProfessionalAuditType
          sections: Array<{
            __typename?: 'ProfessionalAuditSection'
            uid: string
            summary: any
            outcome?: Types.ProfessionalAuditOutcome | null
          }>
        }
      } | null
    } | null
    latestAnswer?: { __typename?: 'Message'; id: number } | null
    chat: {
      __typename?: 'MessagesCollection'
      items: Array<{
        __typename?: 'Message'
        appointmentAt?: any | null
        approvedAt?: any | null
        content?: string | null
        createdAt: any
        id: number
        rejectionReason?: string | null
        sentAt?: any | null
        type: Types.MessageType
        updatedAt: any
        topicQuestionnaireAnswers?: any | null
        messageHasTemplate?: {
          __typename?: 'MessageHasTemplate'
          emailTemplate: { __typename?: 'EmailTemplate'; id: number; name: string }
        } | null
        documents?: Array<
          | {
              __typename?: 'CustomerDocument'
              checked?: boolean | null
              id: number
              name: string
              fileUrl: string
              createdAt: any
              previewImageUrl?: string | null
              fileFormat?: string | null
              documentDate?: any | null
              effective?: boolean | null
              category?: {
                __typename?: 'CustomerDocumentCategory'
                id: number
                name: string
              } | null
              metadata: {
                __typename?: 'MetaData'
                utilityBillCheck?: {
                  __typename?: 'UtilityBillCheck'
                  moveInDate?: string | null
                  moveOutDate?: string | null
                  sizeOfFlat?: number | null
                  isCurrentAddress?: boolean | null
                } | null
              }
              identifiedClauses?: Array<{
                __typename?: 'IdentifiedClause'
                type: string
                effective: boolean
                spans: Array<{
                  __typename?: 'ClauseSpan'
                  text?: string | null
                  page?: number | null
                }>
              }> | null
            }
          | {
              __typename?: 'LawyerDocument'
              id: number
              name: string
              fileUrl: string
              createdAt: any
              previewImageUrl?: string | null
              fileFormat?: string | null
              documentDate?: any | null
              effective?: boolean | null
              identifiedClauses?: Array<{
                __typename?: 'IdentifiedClause'
                type: string
                effective: boolean
                spans: Array<{
                  __typename?: 'ClauseSpan'
                  text?: string | null
                  page?: number | null
                }>
              }> | null
            }
        > | null
        lawyer?: {
          __typename?: 'Lawyer'
          id: number
          firstName: string
          lastName: string
          profilePictureUrl: string
        } | null
        letterRequest?: {
          __typename?: 'LetterRequest'
          id: number
          powerOfAttorney?: {
            __typename?: 'PowerOfAttorney'
            uid: string
            state: Types.PowerOfAttorneyState
            deliveryMethod: Types.DeliveryMethod
          } | null
        } | null
        serviceComment?: {
          __typename?: 'ServiceComment'
          id: number
          comment: string
          updatedAt: any
        } | null
        topic: { __typename?: 'Topic'; id: number; name: string }
        case?: {
          __typename?: 'Case'
          id: number
          state: Types.CaseState
          origin?: string | null
          insuranceClaim?: {
            __typename?: 'InsuranceClaim'
            uuid: string
            insuredPropertyAffiliation?: Types.InsuredPropertyAffiliation | null
            insuredPropertyType?: Types.InsuredPropertyType | null
            services: Array<{
              __typename?: 'InsuranceClaimService'
              uuid: string
              metadata?: any | null
            }>
          } | null
        } | null
        auditReport?: {
          __typename?: 'AuditReport'
          id: number
          report: {
            __typename?: 'ProfessionalAuditReport'
            auditType: Types.ProfessionalAuditType
            sections: Array<{
              __typename?: 'ProfessionalAuditSection'
              uid: string
              summary: any
              outcome?: Types.ProfessionalAuditOutcome | null
            }>
          }
        } | null
      }>
    }
    purchases: {
      __typename?: 'PurchasesCollection'
      last?: {
        __typename?: 'Purchase'
        id: number
        product?: {
          __typename?: 'Product'
          id: number
          name: string
          type: string
          upgradesTo?: Array<number> | null
        } | null
      } | null
    }
    note?: { __typename?: 'CustomerNote'; id: number; note: string } | null
  }
}

export const MembershipFragmentDoc = gql`
  fragment Membership on Membership {
    uuid
    membershipNumber
    activatedAt
    startsAt
    state
    membershipTypeUid
    advancedFrom {
      uuid
    }
    lawyerId
    product {
      id
      name
      type
      upgradesTo
    }
  }
`
export const MessageAttachmentFragmentDoc = gql`
  fragment MessageAttachment on Document {
    id
    name
    fileUrl
    createdAt
    ... on CustomerDocument {
      checked
      category {
        id
        name
      }
      metadata {
        utilityBillCheck {
          moveInDate
          moveOutDate
          sizeOfFlat
          isCurrentAddress
        }
      }
    }
    previewImageUrl
    fileFormat
    documentDate
    effective
    identifiedClauses {
      type
      effective
      spans {
        text
        page
      }
    }
  }
`
export const MessageFragmentDoc = gql`
  fragment Message on Message {
    messageHasTemplate {
      emailTemplate {
        id
        name
      }
    }
    appointmentAt
    approvedAt
    content
    createdAt
    documents {
      ...MessageAttachment
    }
    lawyer {
      id
      firstName
      lastName
      profilePictureUrl
    }
    letterRequest {
      id
      powerOfAttorney {
        uid
        state
        deliveryMethod
      }
    }
    serviceComment {
      id
      comment
      updatedAt
    }
    topic {
      id
      name
    }
    id
    rejectionReason
    sentAt
    type
    updatedAt
    topicQuestionnaireAnswers
    case {
      id
      state
      origin
      insuranceClaim {
        uuid
        insuredPropertyAffiliation
        insuredPropertyType
        services {
          uuid
          metadata
        }
      }
    }
    auditReport {
      id
      report {
        auditType
        sections {
          uid
          summary
          outcome
        }
      }
    }
  }
  ${MessageAttachmentFragmentDoc}
`
export const CustomerFragmentDoc = gql`
  fragment Customer on Customer {
    id
    firstName
    lastName
    gender
    membership {
      ...Membership
    }
    phone
    mobilePhone
    validGermanMobileNumber
    profilePictureUrl
    lawyer {
      id
      firstName
      lastName
      profilePictureUrl
    }
    latestQuestion {
      ...Message
    }
    latestAnswer {
      id
    }
    chat(
      filters: { messageType: { in: [Question, Answer, Information] } }
      sorts: { createdAt: ASC }
    ) {
      items {
        ...Message
      }
    }
    purchases(filters: { isArchived: { not_equals: true } }, sorts: { createdAt: ASC }) {
      last {
        id
        product {
          id
          name
          type
          upgradesTo
        }
      }
    }
    note {
      id
      note
    }
  }
  ${MembershipFragmentDoc}
  ${MessageFragmentDoc}
`
export const CustomerAsLawyerDocument = gql`
  query CustomerAsLawyer($customerId: Int!) {
    customer(id: $customerId) {
      ...Customer
    }
  }
  ${CustomerFragmentDoc}
`
export function useCustomerAsLawyerQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    CustomerAsLawyerQuery,
    CustomerAsLawyerQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<CustomerAsLawyerQuery, CustomerAsLawyerQueryVariables>(
    CustomerAsLawyerDocument,
    options
  )
}
export function useCustomerAsLawyerLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    CustomerAsLawyerQuery,
    CustomerAsLawyerQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<CustomerAsLawyerQuery, CustomerAsLawyerQueryVariables>(
    CustomerAsLawyerDocument,
    options
  )
}
export type CustomerAsLawyerQueryHookResult = ReturnType<typeof useCustomerAsLawyerQuery>
export type CustomerAsLawyerLazyQueryHookResult = ReturnType<typeof useCustomerAsLawyerLazyQuery>
export type CustomerAsLawyerQueryResult = ApolloReactCommon.QueryResult<
  CustomerAsLawyerQuery,
  CustomerAsLawyerQueryVariables
>
export function refetchCustomerAsLawyerQuery(variables?: CustomerAsLawyerQueryVariables) {
  return { query: CustomerAsLawyerDocument, variables: variables }
}
